import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { AudienceWizard } from '@bingads-webui-campaign-react/audience-signals';
import {
  TextTitle,
  getPanelErrorProps,
  ValidatedFixedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { AudienceSignalShimmer, withShimmer } from '@bingads-webui-campaign-react/wizard-shared-components';
import { AudienceImg } from './media';

const AudienceWizardWithShimmer = withShimmer(AudienceWizard, AudienceSignalShimmer);

export const AudienceSignalPanel = (props) => {
  const i18n = useContext(I18nContext);
  const { scope } = useContext(ScopeContext) || {};
  const serverContext = useContext(ServerContext);

  const {
    DynamicPermissions,
    Permissions,
  } = serverContext;

  const { aid, cid } = scope.values;

  const permissions = useMemo(
    () => ({ dynamic: { ...DynamicPermissions }, ...Permissions }),
    [DynamicPermissions, Permissions]
  );

  const isReadOnlyUser = useMemo(
    () => permissions.IsReadOnlyUser || serverContext.CurrentAccount.Status === 32, // 32 is InActive
    [permissions.IsReadOnlyUser, serverContext.CurrentAccount.Status]
  );

  const {
    key,
    isLoading,
    options,
    expand,
    data = {},
    ...rest
  } = props;

  const {
    AudienceGroup,
    OriginalAudienceGroup,
  } = data;

  return (
    <ValidatedFixedPanel
      key={key}
      title={<TextTitle
        titleKey={_TL_('Audience')}
        details={_TL_('Create or add an audience signal to guide automation.')}
        icon={AudienceImg}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
          expand,
          expandKey: key,
        }}
      {...rest}
    >
      <AudienceWizardWithShimmer
        showShimmer={isLoading}
        audienceGroup={AudienceGroup}
        originalAudienceGroup={OriginalAudienceGroup}
        aid={aid}
        cid={cid}
        i18n={i18n}
        isReadOnlyUser={isReadOnlyUser}
        {...options}
      />
    </ValidatedFixedPanel>
  );
};

AudienceSignalPanel.propTypes = {
  key: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  options: PropTypes.shape({
    wizardPerfMarker: PropTypes.shape({}),
  }),
  expand: PropTypes.func,
  wizardPerfMarker: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}),
};

AudienceSignalPanel.defaultProps = {
  isLoading: false,
  options: {},
  data: {},
  expand: () => {},
};
